import { IconDistance } from '@medifind/icons';
import { RadiusFilter } from '@medifind/search-results';
import { useTrialRadiusFilter } from '@medifind/zustand';
import LocationFooter from './LocationFooter';
import Step from './Step';
import styles from './StepShared.module.scss';

const DistanceStep = ({ stepKey, handleStepSubmit, trialCount, showOptional, loading }) => {
  const trialRadius = useTrialRadiusFilter();
  const handleRadiusChange = (selection) => {
    if (selection) {
      handleStepSubmit({ doNotAdvance: true, data: { value: selection?.value, display: selection?.display } });
    }
  };

  return (
    <Step
      title="Distance"
      subTitle="How far is the patient willing to travel?"
      icon={<IconDistance />}
      footer={<LocationFooter />}
      optionsColStyles={styles['distance-step']}
      trialCount={trialCount}
      showTrialCount
      showOptional={showOptional}
      loading={loading}
    >
      <RadiusFilter noHeader filter={trialRadius} onRadiusChange={(arg) => handleRadiusChange(arg)} hideReset={true} />
    </Step>
  );
};

export default DistanceStep;
